<template>
  <div :class="{'layout': true, 'collapse': collapse, 'is-study': isStudyPage}">
    <div v-show="!isStudyPage" class="layout-top">
      <el-row>
        <el-col :span="8" class="layout-top-left">
          <img :src="logoUrl" class="layout-logo" @click="redirect('/user/center')" alt="" /><span class="ly-version">{{version}}</span>
        </el-col>
        <el-col :span="16" class="layout-top-right">
          <div class="inline-block link-icon-box">
            <router-link to="/user/center" title="个人信息">
              <i class="link-icon usercenter"></i><span>个人信息</span>
            </router-link>
            <router-link to="/user/studyrecord" title="学习记录">
              <i class="link-icon studyrecord"></i><span>学习记录</span>
            </router-link>
            <router-link to="/user/ranking" title="排行榜">
              <i class="link-icon ranking"></i><span>排 行 榜</span>
            </router-link>
            <router-link to="/help/buytip" title="购买须知">
              <i class="link-icon buytip"></i><span>购买须知</span>
            </router-link>
          </div>
          <div class="pointer inline-block" @click="redirect('/user/notice')">
            <el-badge :value="noticeCount" :max="10">
              <i class="iconfont icon-notice" title="消息通知"></i>
            </el-badge>
          </div>
          <div class="link inline-block">
            <span @click="redirect('/user/center')" class="pointer">{{authentication.nick}}</span>
            <span class="c21">，</span>
            <span @click="logout" class="pointer">退出</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="layout-toolbar clear-f">
      <div v-show="!isStudyPage" class="toggle-menu" @click='toggleMenu'>
        <i class="iconfont icon-collapse"></i>
        <span v-if="!collapse">网站导航</span>
      </div>
      <div class="toolbar-right clear-f">
        <div class="local">
          <i class="el-icon-location" title="你所在的位置"></i>
          <template v-if="navigation && navigation.length > 0">
            <template v-for="(nav, index) in navigation">
              <router-link v-if="nav.path" :key="'nav_link_' + index" :to="nav.path">{{nav.name}}</router-link>
              <span v-else :key="'nav_link_' + index" class="nolink">{{nav.name}}</span><span
                v-if="index < navigation.length - 1" :key="'nav_spliter_' + index" class="split">/</span>
            </template>
          </template>
          <template v-else>
            <span class="nolink">迷路了...</span>
          </template>
        </div>
        <div v-show="!isStudyPage" class="tc" v-if="progress && progress.cid > 0">
          <span>继续学习：</span><router-link :to="'/course/study/' + progress.cid">{{progress.pname}}/{{progress.uname}}/{{progress.gname}}/{{progress.cname}}</router-link>
        </div>
      </div>
    </div>
    <div class="layout-body clear-f">
      <div v-show="!isStudyPage" class="layout-left">
        <el-menu class="layout-menu" :collapse='collapse' mode="vertical" :default-active="activePath">
          <template v-for="(item, index) in phases">
            <el-menu-item v-if="!item.units || item.units.length === 0" :key="'phases_' + item.id" :index="'phases_' + item.id">
              <i :class="'icon m-phases' + (index + 1)" />
              <span slot="title">{{item.name}}</span>
            </el-menu-item>
            <el-submenu v-else :key="'phases_' + item.id" :index="'phases_' + item.id">
              <template slot="title">
                <i :class="'icon m-phases' + (index + 1)" />
                <span slot="title">{{item.name}}</span>
              </template>
              <el-menu-item v-for="child in item.units" :key="'unit_' + child.id" :index="'/course/unit/' + child.id" @click="redirect('/course/unit/' + child.id)">
                <span slot="title">{{child.name}}</span>
              </el-menu-item>
            </el-submenu>
          </template>
          <template v-for="item in menus" v-if="authentication.isAdmin || !item.adminFun">
            <el-menu-item v-if="!item.children || item.children.length === 0" :key="item.name" :index="item.path" @click="redirect(item.path)">
              <i :class="item.icon || 'el-icon-menu'" />
              <span slot="title">{{item.name}}</span>
            </el-menu-item>
            <el-submenu v-else :index="item.name" :key="item.name">
              <template slot="title">
                <i :class="item.icon || 'el-icon-menu'" />
                <span slot="title">{{item.name}}</span>
              </template>
              <el-menu-item v-for="child in item.children" :key="child.path" :index="child.path" @click="redirect(child.path)">
                <span slot="title">{{child.name}}</span>
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
      </div>
      <div class="layout-main">
        <keep-alive>
          <router-view v-if="keepAlive" class="layout-view"></router-view>
        </keep-alive>
        <router-view v-if="!keepAlive" class="layout-view"></router-view>
        <div class="copyright">Copyright © {{year}} 上海爱听教育科技有限公司</div>
      </div>
    </div>
  </div>
</template>

<script>
let logoUrl = require('assets/image/logo.jpg')

export default {
  name: 'layout',
  data () {
    return {
      menus: window.itingMenu,
      logoUrl,
      year: new Date().getFullYear(),
      version: window.appConfig.version,
      heartInterval: null,
      loading: null,
      logouted: false
    }
  },
  computed: {
    noticeCount () {
      return this.$store.getters.unReadNoticeCount
    },
    collapse () {
      return this.$store.getters.menuCollapse
    },
    navigation () {
      return this.$store.getters.navigation
    },
    activePath () {
      return this.$route.path
    },
    keepAlive () {
      return this.$route.meta && this.$route.meta.keepAlive
    },
    phases () {
      return this.$store.getters.phases
    },
    authentication () {
      return this.$store.getters.authentication
    },
    progress () {
      return this.$store.getters.progress
    },
    isStudyPage () {
      return this.$route.name === 'courseStudy'
    }
  },
  created () {
    this.initMenu()
  },
  mounted () {
    // 心跳请求，每分钟一次，告诉服务端，当前用户在线
    this.heartInterval = setInterval(() => {
      this.$http.get('user/heartbeat')
        .then(response => {

        })
    }, window.appConfig.heartbeat)
  },
  beforeDestroy () {
    clearInterval(this.heartInterval)
  },
  methods: {
    redirect (path) {
      if (path) {
        this.$router.push(path)
      }
    },
    logout () {
      this.logouted = true
      this.$store.dispatch('invalidAuthentication')
      this.redirect('/login')
    },
    toggleMenu () {
      this.$store.dispatch('toggleMenu')
      // 300ms后触发resize事件，echarts重绘
      setTimeout(() => {
        if (document.createEvent) {
          var event = document.createEvent('HTMLEvents')
          event.initEvent('resize', true, true)
          window.dispatchEvent(event)
        } else if (document.createEventObject) {
          window.fireEvent('onresize')
        }
      }, 300)
    },
    initMenu () {
      if (this.phases.length === 0) {
        this.$store.dispatch('getPhases')
      }
    }
  },
  watch: {
    authentication (newVal) {
      if (!this.logouted) {
        // 判断登录信息是否失效
        if (typeof newVal === 'undefined' || !newVal || !newVal.token) {
          this.$message.error('登录信息失效，请重新登录！')
          this.redirect('/login')
        }
      }
    },
    '$store.getters.loading': function (newVal) {
      if (newVal) {
        // 显示加载中蒙版
        if (!this.loading) {
          this.loading = this.$loading({
            target: '.view-content',
            lock: true,
            text: '拼命加载中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.5)'
          })
        }
      } else {
        // 关闭加载中蒙版
        setTimeout(() => {
          if (this.loading) {
            this.loading.close()
            this.loading = null
          }
        }, 300)
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/layout.vue